module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0084.jpg?v=658542ee";